import type { LeadFilterSectionDef } from "./types";

/**
 * In-process registry of industry-specific lead filter sections.
 * Filled at app boot by `./boot.ts`, read by `leadFilter.tsx`.
 */
const sections: LeadFilterSectionDef[] = [];

export function registerLeadFilterSection(def: LeadFilterSectionDef): void {
  // Allow idempotent registration (HMR re-runs boot.ts during dev).
  const idx = sections.findIndex(
    (s) =>
      s.id === def.id &&
      JSON.stringify(s.industryIds) === JSON.stringify(def.industryIds),
  );
  if (idx >= 0) {
    sections[idx] = def;
  } else {
    sections.push(def);
  }
}

export function getSectionsForIndustry(
  industryId: number | undefined,
): LeadFilterSectionDef[] {
  if (industryId == null) {
    // Without an industry the safest default is "show everything that's
    // registered for all industries" (industryIds: []).
    return sections.filter((s) => s.industryIds.length === 0);
  }
  return sections.filter(
    (s) => s.industryIds.length === 0 || s.industryIds.includes(industryId),
  );
}

/** Test-only: clear registrations between unit tests. */
export function _clearLeadFilterRegistryForTests(): void {
  sections.length = 0;
}
